import React, { useEffect, useState } from "react";
import { DatePicker, Typography } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment";
// import styles from "../../assets/styles/modules/Common/Calendar.module.css";
import "../../assets/styles/local/Calender.css";

const currentMonthName = moment().format("MMM YYYY");

const CalendarSlider = ({
  openCalender,
  setDates,
  setOpenCalender,
  setInformationDate,
}) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}>
        <DatePicker
          open
          onSelect={(date) => {
            setDates &&
              setDates(
                moment(new Date(date)).day("Monday").format("DD.MM.YYYY")
              );
            setOpenCalender && setOpenCalender(false);
            setInformationDate &&
              setInformationDate(moment(new Date(date)).format("DD/MM/YYYY"));
          }}
          picker="date"
          style={{
            width: 0,
            position: "absolute",
            zIndex: 1,
            opacity: 0,
            bottom: "-10px",
            right: "230px",
          }}
        />
        {/* <div
          style={{
            padding: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#00246A",
            borderRadius: "8px 8px 0 0",
            color: "white",
          }}>
          <LeftOutlined onClick={decrementMonth} />
          <Typography.Title
            level={5}
            style={{
              margin: 0,
              fontWeight: "400",
              fontSize: "13px",
              color: "white",
            }}>
            {headerMonth}
          </Typography.Title>
          <RightOutlined onClick={incrementMonth} />
        </div> */}
        <div style={{ display: "none" }}></div>
      </div>
    </div>
  );
};

export default CalendarSlider;
